/**
 * Minimal FontAwesome registry for storefront runtime (header, PLP, cart, CMS sections).
 * Studio-only icons live in `icon-library-studio.ts` and load on studio routes.
 */
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebook, faInstagram, faTiktok, faYoutube } from '@fortawesome/free-brands-svg-icons';

import {
  faArrowLeft,
  faArrowRight,
  faCartShopping,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faClock,
  faClose,
  faHeart,
  faLock,
  faPlus,
  faSearch,
  faShoppingCart,
  faTrash,
  faUser,
  faUserCircle,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowLeft as faArrowLeftSolid,
  faBars,
  faCartShopping as faCartShoppingSolid,
  faCheck as faCheckSolid,
  faChevronDown as faChevronDownSolid,
  faChevronLeft as faChevronLeftSolid,
  faChevronRight as faChevronRightSolid,
  faChevronUp,
  faClose as faCloseSolid,
  faEnvelope as faEnvelopeSolid,
  faFilterList,
  faHeart as faHeartSolid,
  faMagnifyingGlass,
  faMinus,
  faPhone as faPhoneSolid,
  faPlus as faPlusSolid,
  faRightFromBracket as faRightFromBracketSolid,
  faStar,
  faTimes,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons';

library.add(
  faArrowLeftSolid,
  faBars,
  faCartShoppingSolid,
  faCheckSolid,
  faChevronDownSolid,
  faChevronLeftSolid,
  faChevronRightSolid,
  faChevronUp,
  faCloseSolid,
  faEnvelopeSolid,
  faFilterList,
  faHeartSolid,
  faMagnifyingGlass,
  faMinus,
  faPhoneSolid,
  faPlusSolid,
  faRightFromBracketSolid,
  faStar,
  faTimes,
  faXmark,
  faArrowLeft,
  faArrowRight,
  faCartShopping,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faClock,
  faClose,
  faHeart,
  faLock,
  faPlus,
  faSearch,
  faShoppingCart,
  faTrash,
  faUser,
  faUserCircle,
  faFacebook,
  faInstagram,
  faTiktok,
  faYoutube,
);
